import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';


@Component({
  selector: 'page-holzsysteme',
  templateUrl: 'holzsysteme.html',
})
export class HolzsystemePage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad HolzsystemePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/holzsysteme/holzsysteme.ts